/**
 * Web Vitals - Monitoreo de performance
 * 
 * Mide Core Web Vitals y envía a GA4
 */

import { onCLS, onINP, onLCP, onFCP, onTTFB, type Metric } from 'web-vitals';

/**
 * Enviar métrica a Google Analytics
 */
function sendToAnalytics(metric: Metric) {
  if (typeof window === 'undefined' || !(window as any).gtag) return;

  const value = Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value);

  (window as any).gtag('event', metric.name, {
    value,
    event_category: 'Web Vitals',
    event_label: metric.id,
    non_interaction: true,
  });

  // Log en desarrollo
  if (import.meta.env.DEV) {
    console.log(`📊 ${metric.name}:`, value, metric.rating);
  }
}

/**
 * Inicializar monitoreo de Web Vitals
 */
export function reportWebVitals() {
  onCLS(sendToAnalytics);
  onINP(sendToAnalytics);
  onLCP(sendToAnalytics);
  onFCP(sendToAnalytics);
  onTTFB(sendToAnalytics);
}
